import { Loadable } from '../../components/common/loadable/loadable';

export const SelectOrganizationContainer = Loadable<any>({
  loader: () =>
    import(
      /* webpackChunkName: "select-organization" */ './select-organization'
    ).then((module) => module.SelectOrganizationContainer),
});
